import { Stack, Skeleton } from "@mui/material";
import { random, uniqueId } from "lodash";

interface ColumnViewSkeletonProps {
  columns?: number;
  minSlots?: number;
  maxSlots?: number;
}

const ColumnHeaderSkeleton = () => (
  <Stack
    direction="row"
    spacing={1}
    alignItems="center"
    justifyContent="space-between"
  >
    <Skeleton variant="rounded" width="100px" />
  </Stack>
);

const ColumnSlotsSkeleton = ({ minSlots = 4, maxSlots = 12 }) => (
  <Stack direction="column" sx={{ paddingTop: 2 }} spacing="12px" width="100%">
    {Array(random(minSlots, maxSlots))
      .fill(null)
      .map(() => (
        <Skeleton key={uniqueId("slot_")} variant="rounded" height="40px" />
      ))}
  </Stack>
);

export const ColumnViewSkeleton = ({
  columns = 5,
  minSlots = 4,
  maxSlots = 12
}: ColumnViewSkeletonProps) => (
  <>
    {Array(columns)
      .fill(null)
      .map(() => (
        <Stack
          key={uniqueId("column_")}
          direction="column"
          alignItems="center"
          flex={1}
        >
          <ColumnHeaderSkeleton />
          <ColumnSlotsSkeleton minSlots={minSlots} maxSlots={maxSlots} />
        </Stack>
      ))}
  </>
);
